import React, { useContext } from 'react';
import SummaryCard from '../../../components/SummaryCard';
import { TimeRangeButton, TimeRangeNavigator } from '../../../components/ui';
import { NotebookContext } from '../../../context/NotebookContext';
import EmptyState from './EmptyState';
import NewButton from './NewButton';
import { orderBy } from 'lodash';

interface DashboardItem {
  slug: string;
  name: string;
  id: string;
  subjects?: {
    id: string;
  }[];
  trackers: {
    id: string;
    name: string;
    slug: string;
    type: TrackerType;
  }[];
  type: 'GROUP' | 'SUBJECT';
}

type DashboardArray = DashboardItem[];

const Dashboard = () => {
  const { notebook } = useContext(NotebookContext);

  const dashboardItems: DashboardArray = [];
  notebook.groups.forEach(group =>
    dashboardItems.push({
      id: group.id,
      slug: group.slug,
      name: group.name,
      trackers: group.trackers,
      subjects: group.subjects,
      type: 'GROUP'
    })
  );
  notebook.ungroupedSubjects.forEach(subject =>
    dashboardItems.push({
      id: subject.id,
      slug: subject.slug,
      name: subject.name,
      type: 'SUBJECT',
      trackers: subject.trackers
    })
  );

  const alphaItems = orderBy(dashboardItems, item => item.name);

  return (
    <div
      className="w-100 center pv4 pv5-ns"
      style={{
        maxWidth: 695
      }}
      data-testid="dashboard-list"
    >
      <div className="flex justify-between mb3">
        <div className="flex">
          <TimeRangeButton />
          <TimeRangeNavigator />
        </div>
        <NewButton />
      </div>

      {alphaItems.length > 0 ? (
        alphaItems.map(item => <SummaryCard key={item.id} item={item} />)
      ) : (
        <EmptyState />
      )}
    </div>
  );
};

export default Dashboard;
